import { Typography } from "@material-ui/core";
import React from "react";

export default function FileTypeCancel(props) {
  const file = props.file;
  let fileFormatIcon = "";
  switch (file?.ext?.toLowerCase()) {

    case ".pdf":
      fileFormatIcon = "/assets/pdf.svg"
      break;
    case ".jpg":
      fileFormatIcon = "/assets/jpg.svg"
      break;
    case ".xls":
      fileFormatIcon = "/assets/xls.svg"
      break;
    default:
      fileFormatIcon = "/assets/fileFormat.svg";
      break;
  }


  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "row",
      }}
    >
      <img src={fileFormatIcon} alt={`${file.fileName}-file-icon`} />
      <div
        style={{
          marginLeft: 34,
          textAlign: "left",
        }}
      >
        <Typography variant="h6">{file.fileName}{file.ext}</Typography>
        {/* <Typography>{fileName || "File name: -"}</Typography> */}
      </div>
    </div>
  );
}
